// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraLinkLabelTemplate from '@front/templates/TerceraLinkLabelTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { Control } from './Control';
export class TerceraLinkLabel extends Control {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.TerceraLinkLabel;
    }
    oninit() {
        this.on('linkClick', this.private_LinkClick);
    }
    private_LinkClick(sender) {
        this.fire(TerceraLinkLabelEvents.Click, sender);
    }
}
export var TerceraLinkLabelEvents;
(function (TerceraLinkLabelEvents) {
    TerceraLinkLabelEvents["Click"] = "onClick";
})(TerceraLinkLabelEvents || (TerceraLinkLabelEvents = {}));
Control.extendWith(TerceraLinkLabel, {
    template: TerceraLinkLabelTemplate,
    data: function () {
        return {
            subclass: '', // for css styling
            text: 'test text from TerceraLinkLabel (default)',
            linkHref: ''
        };
    }
});
